import { useEffect, useState } from 'react';
import { Button, Modal } from 'semantic-ui-react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [joyrideActive, setJoyrideActive] = useState(false);

  // ✅ only allow on mobile browsers
  const isMobile =
    typeof navigator !== 'undefined' &&
    /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  // Check if joyride tutorial is active by looking for its overlay element
  useEffect(() => {
    const checkJoyride = () => {
      const joyrideOverlay = document.querySelector('.react-joyride__overlay');
      setJoyrideActive(!!joyrideOverlay);
    };

    // Check initially and set up observer for DOM changes
    checkJoyride();
    const observer = new MutationObserver(checkJoyride);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isMobile) return; // skip setup if not on mobile

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        'beforeinstallprompt',
        handleBeforeInstallPrompt,
      );
    };
  }, [isMobile]);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      console.log('User accepted install');
    } else {
      console.log('User dismissed install');
    }
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  const handleClose = () => {
    setShowPrompt(false);
  };

  // ✅ render nothing on desktop
  if (!isMobile) return null;

  return (
    <Modal
      open={showPrompt && !joyrideActive}
      onClose={handleClose}
      size="tiny"
    >
      <Modal.Header>Install this app?</Modal.Header>
      <Modal.Content>
        <p>
          Install this app on your device for quicker access and a better
          experience.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleClose}>Later</Button>
        <Button primary onClick={handleInstall}>
          Install
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default InstallPrompt;
